/**
 * Przełącznik trybu ciemnego — stan w localStorage (krok 5.5).
 */

const STORAGE_KEY = 'sn-theme';
const THEME_DARK = 'dark';
const THEME_LIGHT = 'light';
const META_THEME_DARK = '#0d1520';
const META_THEME_LIGHT = '#0f2f59';

function syncToggleButton(theme) {
    const btn = document.getElementById('theme-toggle');
    if (!btn) {
        return;
    }

    const isDark = theme === THEME_DARK;
    btn.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    btn.setAttribute('aria-label', isDark ? 'Włącz tryb jasny' : 'Włącz tryb ciemny');
}

export function applyTheme(theme) {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme === THEME_DARK ? THEME_DARK : THEME_LIGHT);

    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
        meta.setAttribute('content', theme === THEME_DARK ? META_THEME_DARK : META_THEME_LIGHT);
    }

    try {
        localStorage.setItem(STORAGE_KEY, theme === THEME_DARK ? THEME_DARK : THEME_LIGHT);
    } catch (_) {
        // localStorage niedostępny (np. tryb prywatny) — UI nadal działa w sesji
    }

    syncToggleButton(theme);
}

export function getStoredTheme() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === THEME_DARK || stored === THEME_LIGHT) {
            return stored;
        }
    } catch (_) {
        return THEME_LIGHT;
    }

    return THEME_LIGHT;
}

export function initThemeToggle() {
    const btn = document.getElementById('theme-toggle');
    if (!btn) {
        return;
    }

    const current = document.documentElement.getAttribute('data-theme') || getStoredTheme();
    syncToggleButton(current);

    btn.addEventListener('click', () => {
        const isDark = document.documentElement.getAttribute('data-theme') === THEME_DARK;
        applyTheme(isDark ? THEME_LIGHT : THEME_DARK);
    });
}
